/* DefinitionSource.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./DefinitionSource.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import { Anchor, Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { useAIAnswerContext } from '../../../../ai-answer-dialog/ai-answer-context';
import { onAIAnswerSourceClick } from '../../../../ai-answer-dialog/analytics';
import { AppIcon } from '../../../../common/ui/app-icon/app-icon';
var toTitleCase = function toTitleCase(sourceCategory) {
  return sourceCategory.split(' ').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
};
var styles = {
  root: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
  sourceIconWrapperStyles: "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb7vkz _4t3i7vkz"
};
export var DefinitionSource = function DefinitionSource(_ref) {
  var _sourceData$data$gene, _sourceData$entityDat;
  var sourceData = _ref.sourceData,
    index = _ref.index;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent;
  var is1PSource = ((_sourceData$data$gene = sourceData.data.generator) === null || _sourceData$data$gene === void 0 ? void 0 : _sourceData$data$gene.name) === 'Confluence';
  var sourceMetadata = is1PSource ? sourceData.data.summary : (_sourceData$entityDat = sourceData.entityData) !== null && _sourceData$entityDat !== void 0 && _sourceData$entityDat.type ? toTitleCase(sourceData.entityData.type.category) : undefined;
  var onClickSource = useCallback(function () {
    var _sourceData$data$gene2;
    fireAnalyticsEvent(onAIAnswerSourceClick(_objectSpread({
      sourceIndex: index,
      sourceProduct: ((_sourceData$data$gene2 = sourceData.data.generator) === null || _sourceData$data$gene2 === void 0 ? void 0 : _sourceData$data$gene2.name.toLowerCase()) || ''
    }, commonAttributes)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fireAnalyticsEvent, commonAttributes]);
  return /*#__PURE__*/React.createElement(Anchor, {
    href: sourceData.data.url,
    xcss: styles.root,
    target: "_blank",
    onClick: onClickSource
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.100"
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    space: "space.100"
  }, sourceData.data.generator && /*#__PURE__*/React.createElement(AppIcon, {
    app: sourceData.data.generator.name.toLowerCase(),
    size: "xxsmall"
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    color: "color.text",
    maxLines: 1,
    weight: "medium"
  }, sourceData.data.name))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    maxLines: 2,
    color: "color.text.subtle",
    size: "small"
  }, sourceMetadata))));
};